import {IntermediatePart} from "../../intermediatePart";

export default class Frame extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'frame';
    this.partName = 'Frame';
    this.translateId = "visualizer.bathroom.frame";
    this.canBeDisabled = true;
  }

}
